
/**
 * @ENV
 */
export default {
    NAMESPACE_ATTR: 'namespace',
    SCOPED_ID_ATTR: 'scoped:id',
    NAMESPACE_PROP: 'namespace',
    SCOPED_ID_INERT_CONTEXTS: [],
};